export default function createEnvironments(baseUrl: string, userManagementUrl?: string, prodUserManagementUrl?: string) {
  const nestUrl = '/ui/api';
  const apiEndpoint = '/api';

  const createUrl = (urlPath: string, urlPrefix: string = baseUrl) => {
    if (!urlPrefix.endsWith('/')) {
      urlPrefix = urlPrefix + '/';
    }

    return (
      urlPrefix +
      urlPath
        .split('/')
        .filter((el) => el.length > 0)
        .join('/')
    );
  };

  return {
    production: false,

    products: {
      get: createUrl(apiEndpoint + '/air-treatment/products'),
      fields: {
        fetch: createUrl(apiEndpoint + '/air-treatment/products/features'),
      },
      exactModel: createUrl(apiEndpoint + '/air-treatment/products/find-models'),
      suggestModel: createUrl(apiEndpoint + '/air-treatment/products/suggested-models'),
      downloadPdf: createUrl(apiEndpoint + '/file/images/generate-pdf'),
      specificModel: createUrl(apiEndpoint + '/air-treatment/products/specific-model?specificModel={specificModel}'),
    },
    images: {
      get: createUrl(apiEndpoint + '/file/images'),
      getImagePath: createUrl(apiEndpoint + '/file/images/image-path'),
      getActualModelImagePath: createUrl(apiEndpoint + '/file/images/model-image'),
    },
    dryersTypes: {
      get: createUrl(apiEndpoint + '/air-treatment/products/dryer-groups-and-types'),
    },
    getAllModels: {
      get: createUrl(apiEndpoint + '/air-treatment/products/models'),
      post: createUrl(apiEndpoint + '/air-treatment/products/model-names'),
    },
    costComparison: {
      post: createUrl(apiEndpoint + '/air-treatment/cost-comparison'),
      chart: createUrl(apiEndpoint + '/air-treatment/cost-comparison/chart'),
    },
    units: {
      formulas: createUrl(apiEndpoint + '/air-treatment/unit'),
    },
    sso: {
      authorizationUrl: createUrl(apiEndpoint + '/sso/authorization-url'),
      callback: createUrl(apiEndpoint + '/sso/callback'),
    },
    login: {
      apiEndpoint: userManagementUrl + '/api/v3/login',
      logout: userManagementUrl + '/api/v3/logout',
    },
    auth: {
      login: createUrl(apiEndpoint + '/auth/login'),
      logout: createUrl(apiEndpoint + '/auth/logout'),
      brandToken: createUrl(apiEndpoint + '/auth/brand-token'),
    },
    user: {
      recoverPassword: (prodUserManagementUrl ?? userManagementUrl) + '/api/v2/user/productselection/resetpassword',
      resetPassword: (prodUserManagementUrl ?? userManagementUrl) + '/api/v2/user/{username}/resetpassword/{token}',
      checkResetPasswordToken: (prodUserManagementUrl ?? userManagementUrl) + '/api/v2/user/check/{username}/{token}',
    },
  };
}
